
const ComingSoon = () => {
  return (
    <div className="coming-soon-container" style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div className="text-center" style={{
        background: 'rgba(255,255,255,0.95)',
        padding: '60px 40px',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        maxWidth: '600px',
        width: '100%'
      }}>
        <div style={{ fontSize: '80px', marginBottom: '20px' }}>🚧</div>
        <h1 style={{
          color: '#0D9488',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          marginBottom: '20px'
        }}>
          Coming Soon
        </h1>
        <h2 style={{
          color: '#0B7A6F',
          fontSize: '1.8rem',
          marginBottom: '30px'
        }}>
          जल्द ही आ रहा है
        </h2>
        <p style={{
          color: '#666',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          marginBottom: '40px'
        }}>
          This service is currently under development. We're working hard to bring you the best experience.
          <br />
          यह सेवा वर्तमान में विकास के अधीन है। हम आपको सर्वोत्तम अनुभव प्रदान करने के लिए कड़ी मेहनत कर रहे हैं।
        </p>
        <button 
          onClick={() => window.history.back()}
          style={{
            background: 'linear-gradient(135deg, #0D9488 0%, #0B7A6F 100%)',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '50px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 5px 15px rgba(13, 148, 136, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(13, 148, 136, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 5px 15px rgba(13, 148, 136, 0.3)';
          }}
        >
          ← Go Back / वापस जाएं
        </button>
      </div>
    </div>
  );
};

export default ComingSoon;